'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import AreaSelectController from "./controller/areaSelect";
import AreasController from "./controller/areas";
import AreaModalCreateController from "./controller/areaModalCreate";
import AreaTableDirective from "./directive/areaTable";
import AreaSelectDirective from "./directive/areaSelect";
import AreaService from "./service/area";

export default angular.module('investmentProject.area', [])
    .controller('AreaSelectController', AreaSelectController)
    .controller('AreasController', AreasController)
    .controller('AreaModalCreateController', AreaModalCreateController)
    .directive('areaTable', AreaTableDirective)
    .directive('areaSelect', AreaSelectDirective)
    .factory('AreaService', AreaService)
    .name;
